import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';

export const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (props) => props !== 'disablePadding'
})(({ disablePadding }) => ({
  ...(disablePadding
    ? {
        paddingTop: 0,
        paddingBottom: 0
      }
    : {})
}));



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormCheckbox/styles.js